/*
 *  Bootstrap Nice Select Chinese (Simplified, People's Republic of China) Translation
 *  Author: Kevin Gostomski <kevingostomski2001@gmail.com> 
*/

const localisation = {
    locales: []
}

localisation.locales['zh-ZN'] = localisation.locales['zh'] = {
    formatSearch() {
        return "搜索中...";
    },
    formatHelpForTagging() {
        return "要创建自己的标签，请聚焦输入字段，然后按'Enter'或','或“空格键”将其添加到列表中";
    }
}

export default localisation;